module.exports = __webpack_public_path__ + "static/Intro-2bc9499a6a0991feb4890b71653753d9.svg";